import { AxiosChatInstance, AxiosPublicationsInstance } from "../api/AxiosInstance";

export const generateVisitId = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/obtener/busqueda-housing/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed generate visit id";
  }
};

export const getApplicationsProperties = async () => {
  try {
    const response = await AxiosPublicationsInstance.get("/api/obtener/sugerencias-housing/externo");
    return response;
  } catch (error) {
    throw error?.response || "Failed get applications properties";
  }
}

export const getLocationRecomendations = async (query) => {
  try {
    const response = await AxiosChatInstance.get(`/api/autocompletar/busqueda?query=${query}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get location recomendations"
  }
};


export const insertLocation = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/ubicacion-especifica/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert location";
  }
};

export const getParkingOptions = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/obtener/catalogo-estacionamientos/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get parking options";
  }
};

export const insertParking = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/lugar-estacionamiento/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert parking";
  }
};

export const getAmenities = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/get/amenidades/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get amenities";
  }
};

export const insertAmenities = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/amenidades-visitante/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert amenities";
  }
};

export const insertDate = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/fecha-mudanza/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert date";
  }
};

export const getPersonalOptions = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/obtener/catalogo-convivencia/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get personal options";
  }
};

export const getNationalityOptions = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/obtener/catalogo-nacionalidad/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get nationality options";
  }
};

export const insertPersonalOptions = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/personas-convivencia/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert personal options";
  }
};

export const getBudgetOptions = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/obtener/ingreso-mensual/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get budget options";
  }
};

export const insertBudgetOptions = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/ingreso-mensual/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert budget options";
  }
};

export const insertEvictionNotice = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/desalojo-visitante/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert eviction notice";
  }
};

export const InsertApplicationsHousing = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/obtener/onboarding-externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get applications housing";
  }
};

export const getPetOptions = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(
      "/api/obtener/catalogo-mascotas/externo"
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed get pet options";
  }
};

export const insertPetOptions = async (payload) => {
  try {
    const response = await AxiosPublicationsInstance.post(
      "/api/insertar/tipo-mascota/externo",
      payload
    );
    return response;
  } catch (error) {
    throw error?.response || "Failed insert pet options";
  }
};
